<template>
  <div class="row">
    <div class="col-sm-3">
      <h4>{{ language | t }}</h4>
    </div>
    <div class="col-sm-8">
      <webshipper-input-string v-model="locale_type.value" :label="'value'"></webshipper-input-string>
      <webshipper-input-string
        v-if="attribute_type.input_type === 'boolean'"
        v-model="locale_type.key"
        :label="'key'"
      ></webshipper-input-string>
      <webshipper-input-string
        v-if="attribute_type.input_type === 'boolean'"
        v-model="locale_type.description"
        :label="'description'"
      ></webshipper-input-string>
    </div>
  </div>
</template>
<script>
// @ts-check
import languages from '@cospired/i18n-iso-languages';

// @ts-ignore
languages.registerLocale(require('@cospired/i18n-iso-languages/langs/en.json'));

export default {
  props: {
    locale_type: {
      type: Object,
      required: true
    },
    attribute_type: {
      type: Object,
      required: false
    }
  },
  computed: {
    language() {
      return languages.getName(this.locale_type.locale, 'en');
    }
  }
};
</script>
